import React from "react";

const DashboardSuccessSVG = ({ className }) => {
  return (
    <svg
      width="125"
      height="124"
      viewBox="0 0 125 124"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M43.5449 55.791C57.7781 55.791 69.3164 44.2527 69.3164 30.0195C69.3164 15.7863 57.7781 4.24805 43.5449 4.24805C29.3117 4.24805 17.7734 15.7863 17.7734 30.0195C17.7734 44.2527 29.3117 55.791 43.5449 55.791Z"
        fill="#2EC465"
      />
      <path
        d="M65.5696 43.4123L64.5461 41.2175C60.873 33.3405 51.4758 29.9197 43.5984 33.5933C35.7209 37.2665 32.3009 46.6636 35.974 54.5409L36.0388 54.6797C38.4144 55.4019 40.935 55.7919 43.5468 55.7919C52.8754 55.7921 61.0462 50.8354 65.5696 43.4123Z"
        fill="#01B544"
      />
      <path
        d="M57.8443 51.4568C64.7563 46.8344 69.3085 38.9592 69.3085 30.0197C69.3085 15.7863 57.7703 4.24805 43.5371 4.24805C29.3039 4.24805 17.7656 15.7863 17.7656 30.0195C17.7656 44.2527 29.3039 55.791 43.5371 55.791C45.0057 55.791 46.4451 55.6663 47.8466 55.4303"
        stroke="#5BD387"
        stroke-width="4.38441"
        stroke-miterlimit="10"
        stroke-linejoin="round"
      />
      <path
        d="M36.3457 29.0306L42.2996 34.9843L52.2935 24.9902"
        stroke="white"
        stroke-width="4.38441"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.88447 30.0176H2.77148"
        stroke="#FDCB50"
        stroke-width="4.38441"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.6662 47.8496L8.23828 50.406"
        stroke="#FDCB50"
        stroke-width="4.38441"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.6662 12.1914L8.23828 9.63477"
        stroke="#FDCB50"
        stroke-width="4.38441"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M79.209 30.0176H84.3222"
        stroke="#FDCB50"
        stroke-width="4.38441"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M74.4277 47.8496L78.8559 50.406"
        stroke="#FDCB50"
        stroke-width="4.38441"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M74.4277 12.1914L78.8559 9.63477"
        stroke="#FDCB50"
        stroke-width="4.38441"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M81.5695 49.6828C79.5113 50.6562 78.6333 53.1097 79.6067 55.1679L77.69 51.1151C76.7166 49.0568 74.2632 48.1789 72.2049 49.1523C70.1467 50.1257 69.2687 52.5791 70.2421 54.6374L68.5161 50.9877C67.5427 48.9294 65.0893 48.0515 63.031 49.0249C60.9728 49.9983 60.0948 52.4517 61.0682 54.51L54.4752 40.5691C53.5018 38.5108 51.0484 37.6329 48.9901 38.6063C46.9319 39.5797 46.0539 42.0331 47.0273 44.0914L58.7081 68.7903L59.6815 70.8486L53.5557 68.6565C51.4148 67.8904 49.0595 69.0043 48.2933 71.1452C47.5272 73.2861 48.6411 75.6414 50.782 76.4075L67.2221 83.4716C69.2401 84.3347 70.8647 85.9032 71.7924 87.8922L72.8962 90.2263L95.2399 79.6595L93.3934 75.7552C92.9218 74.7579 92.6355 73.6859 92.5547 72.5817L91.8772 63.2431C91.7964 62.1389 91.5101 61.0669 91.0385 60.0696L88.4896 54.68L87.0446 51.6244C86.0812 49.5874 83.6278 48.7094 81.5695 49.6828Z"
        fill="#FFCCBC"
      />
      <path
        d="M59.6809 70.8536L60.584 72.7633L50.0514 68.9943C51.0778 68.3921 52.3362 68.2254 53.5395 68.656L59.6809 70.8536Z"
        fill="#FCB39F"
      />
      <path
        d="M54.4691 40.5485L65.1966 63.2317C65.3772 63.6136 65.2206 64.0512 64.8387 64.2318C64.4567 64.4124 64.0192 64.2559 63.8385 63.8739L51.762 38.3105C51.8926 38.3397 52.0176 38.3844 52.1426 38.4291C53.1271 38.7814 53.9931 39.5144 54.4691 40.5485Z"
        fill="#FCB39F"
      />
      <path
        d="M68.5043 50.9723L73.2709 61.0514C73.4516 61.4333 73.295 61.8709 72.913 62.0515C72.5311 62.2322 72.0935 62.0756 71.9129 61.6936L65.7971 48.7344C65.9278 48.7635 66.0528 48.8082 66.1778 48.853C67.1623 49.2053 68.0282 49.9382 68.5043 50.9723Z"
        fill="#FCB39F"
      />
      <path
        d="M77.6857 51.0973L81.3685 58.8847C81.5491 59.2667 81.3926 59.7042 81.0106 59.8849C80.6287 60.0655 80.1911 59.9089 80.0105 59.527L74.9729 48.875C75.1035 48.9041 75.2285 48.9488 75.3536 48.9936C76.3537 49.3515 77.204 50.0788 77.6857 51.0973Z"
        fill="#FCB39F"
      />
      <path
        d="M87.057 51.6537L89.4554 56.7251C89.636 57.107 89.4795 57.5446 89.0975 57.7252C88.7156 57.9058 88.278 57.7492 88.0974 57.3673L84.3343 49.4102C84.4649 49.4393 84.5899 49.484 84.7149 49.5287C85.715 49.8866 86.5653 50.614 87.057 51.6537Z"
        fill="#FCB39F"
      />
      <path
        d="M71.9765 88.9977L94.9992 78.1097C97.2484 77.046 99.9207 78.0023 100.984 80.2515L102.901 84.3043C103.965 86.5535 103.009 89.2258 100.759 90.2895L77.731 101.193C75.4818 102.257 72.8096 101.301 71.7459 99.0513L69.8292 94.9985C68.7655 92.7493 69.7273 90.0614 71.9765 88.9977Z"
        fill="var(--bs-primary-400)"
      />
      <path
        d="M70.7948 97.0147L101.929 82.2777L102.892 84.3147C103.956 86.564 103 89.2362 100.75 90.2999L77.7277 101.188C75.4785 102.252 72.8063 101.295 71.7425 99.0461L70.7948 97.0147Z"
        fill="var(--bs-primary-700)"
      />
    </svg>
  );
};

export default DashboardSuccessSVG;
